import React, { createContext, useState, useEffect, useContext } from 'react';
import apiClient from 'helpers/apiService';
import { useAuth } from 'providers/AuthProvider'
export interface MessageType {
    notification_id: number
    function: string;
    level: string;
    message: string;
    icon: string;
    time: string;
    date: string;
    to_read: number;
    inserted_at: string;
}

/**
 export const notifications: Notification[] = [
  {
    id: '1',
    function:'Transcription',    
    interactionIcon: '💬',
    message: 'Transcription #10 in progress',
        
    icon: 'clock',
    time: '10:41 AM ',
    date: 'August 7,2021',
    read: true
  },
 */

interface SSEContextType {
    notifications: MessageType[];
    //message: string;
    markAllNotificationsAsread: () => void;
    //sendMessage: (message: string) => void;
    //closeSocket: () => void;
}

const SSEContext = createContext<SSEContextType | undefined>(null!);

const SSEProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [notifications, setNotifications] = useState<MessageType[]>([]);

    const auth = useAuth();

    const fetchData = async () => {
        //console.log("SSEProvider: fetchData");
        try {
            const response = await apiClient.get(
                '/v1/notifications',
                {
                    headers: {
                        'accept': 'application/json',

                    },
                    withCredentials: true,
                }
            );
            //console.log(response.data);
            setNotifications(response.data);

            /*
            const msg = JSON.parse(response.data);
            const message: MessageType = {
                'id': msg.notification_id,
                'function': msg.function,
                'level': msg.level,
                'message': msg.message,
                'time': msg.time,
                'date': msg.date,
                'read': msg.to_read === true,
                icon: 'clock',
            };
            //console.log(message);
            setMessage(message);
            */

        } catch (error) {
            console.error('Error deleteting a resource:', error);
        }
    };

    const markAllNotificationsAsread = async () => {
        const form = new FormData();
        form.append('cmd', 'all');
        try {
            const response = await apiClient.put('/v1/notifications', form,
                {
                    headers: {
                        'accept': 'application/json',

                    },
                    withCredentials: true,
                }
            );

            if (!notifications || notifications.length === 0) {
                return [];
            }

            // Map over the notifications array and set read_me to false for each object
            const updatedNotifications = notifications.map(notification => ({
                ...notification,
                read: true
            }));
            setNotifications(updatedNotifications);

        } catch (error) {
            console.error('Error markAllNotificationsAsread:', error);
        }
    };

    useEffect(() => {
        // Fetch data immediately when the component mounts
        fetchData();

        // Set up polling every 30 seconds
        const intervalId = setInterval(fetchData, 30000);
        // Clean up the interval on component unmount
        return () => clearInterval(intervalId);
    }, []);


    //clean up function when we close page
    const closeSocket = async () => {

    };

    return (
        <SSEContext.Provider value={{ notifications, markAllNotificationsAsread, /*sendMessage, closeSocket*/ }}>
            {children}
        </SSEContext.Provider>
    );
};

const useSSE = (): SSEContextType => {
    const context = useContext(SSEContext);
    if (context === undefined) {
        throw new Error('useSSE must be used within an SSEProvider');
    }
    return context;
};





/**
 * the SSEProvider component is not exported as the default export because 
 * it's often preferable to have named exports for better clarity and maintainability, 
 * especially in larger codebases or when you have multiple exports from a file.
 * Named exports explicitly state what is being exported from a file, 
 * making it clear to other developers which components, functions, or objects are available for use.
 * 
 * Usage:
 *  import { SSEProvider, useSSE, MessageType } from 'providers/SSEProvider'
 *  const { message, sendMessage, closeSocket } = useSSE();
 */

export { SSEProvider, useSSE };
